<template>
  <div>
    <b-row>
      <b-col class="d-flex justify-content-between pb-1 align-items-center">
        <h1 class="font-weight-bolder">
          {{ $t('users') }}
        </h1>
        <b-button
          :to="{ name: 'new-member', params: { userId: customerResourceId } }"
          variant="primary"
        >
          {{ $t('create', { type: $t('user') }) }}
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-overlay :show="loading">
          <users-table
            :users="users.filter(user => user.id !== currentUser.id)"
            :pagination="pagination"
            :customer-id="customerResourceId"
          />
        </b-overlay>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import UsersTable from '@/views/users/MembersTable.vue'

export default {
  components: {
    UsersTable,
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    ...mapGetters('users', ['users', 'pagination']),
    ...mapGetters('auth', ['currentUser']),

    customerScopedRole() {
      const scopedRoles = Array.isArray(this.currentUser?.scoped_roles) ? this.currentUser.scoped_roles : []
      return scopedRoles.find(role => role.role_name === 'customer' && role.role_resource_type === 'Customer')
        || scopedRoles.find(role => role.role_resource_type === 'Customer')
        || scopedRoles[0]
        || null
    },

    customerResourceId() {
      if (this.currentUser.role_name === 'customer') {
        return this.customerScopedRole?.role_resource_id || this.$route.params.userId
      }
      if (this.currentUser.role_name === 'admin') {
        return this.$route.params.userId
      }
      return this.$route.params.userId
    },
  },

  watch: {
    customerResourceId: {
      immediate: false,
      handler(newValue, oldValue) {
        if (!newValue || newValue === oldValue) return
        this.selectCustomerId(newValue)
        this.fetchUsers({ by_customer: newValue })
      },
    },
  },

  async created() {
    try {
      this.loading = true
      this.selectCustomerId(this.customerResourceId)
      await this.fetchUsers({ by_customer: this.customerResourceId })
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  },

  methods: {
    ...mapActions('users', ['fetchUsers']),
    ...mapMutations('customers', {
      selectCustomerId: 'SELECT_CUSTOMER_ID',
    }),
  },
}
</script>

<style></style>
